<template>
  <subjects @onUpdate="onUpdate" @onReprove="onReprove" :config="config" />
</template>

<script>
import AdminSubjects from "./AdminSubjects"

export default {
  name: 'AdminSubjectsToApprove',
  components: { 'subjects': AdminSubjects },
  data: (vm) => {
    return {
      config: {
        title: 'Cadastros em Análise',
        empty: 'Não existem cadastros para serem aprovados neste momento.',
        navItems: [{ url: '/admin/subjects', title: 'Cadastros Aprovados', icon: 'dashboard' }],
        load_url: vm.$root.urls.admin_companies_for_clearance
      }
    }
  },
  methods: {
    onUpdate(companies, record) {
      if ((record.clearance_level * 1) > 0) {
        companies.splice(companies.findIndex(el => el.id === record.id), 1)
      }
    },
    onReprove(companies, record) {
      companies.splice(companies.findIndex(el => el.id === record.id), 1)
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/AdminSubjectsToApprove.vue